import "./AppleCareImage.scss";
import {Typography } from "mobily-ui-library/lib";
import ACSupport from "../../assets/ACSupport.svg";
import ACBattery from "../../assets/ACBattery.svg";
import ACDamage from "../../assets/ACDamage.svg";
import ACRepair from "../../assets/ACRepair.svg";
import { t } from "i18next";


const AppleCareImage = () => {
  return (
    <>
       <div className="DDAC__CoveredItems">
          <div className="DDAC__Item">
            <img src={ACDamage} alt="apple-damage" className="DDAC_IMG"/>
            <Typography>{t("Damage_protection")}</Typography>
          </div>
          <div className="DDAC__Item">
            <img src={ACRepair} alt="apple-repair" className="DDAC_IMG"/>
            <Typography>{t("Apple_repairs")}</Typography>
          </div>
          <div className="DDAC__Item">
            <img src={ACBattery} alt="apple-battery" className="DDAC_IMG"/>
            <Typography>{t("Battery_warranty")}</Typography>
          </div>
          <div className="DDAC__Item">
            <img src={ACSupport} alt="apple-service" className="DDAC_IMG"/>
            <Typography>{t("Priority_service")}</Typography>
          </div>
        </div>
    </>
  );
};
export default AppleCareImage;
